import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import MoreMenu from 'src/components/MoreMenu/MoreMenu';
import { useTranslation } from 'react-i18next';
import { CommonActions } from 'src/utils/constants/clients';
import ConfirmationDialog from 'src/components/ConfirmDialog/ConfirmationDialog';
import {
  deleteAdministrativeRoleAction,
  editAdministrativeRoleAction
} from 'src/store/actions/catalogActions';
import { useDispatch } from 'react-redux';
import AdministrativeRolesForm from './AdministrativeRolesForm';

const AdministrativeRolesRow = ({ id, name }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [openAdministrativeRoleForm, setOpenAdministrativeRoleForm] = useState(
    false
  );
  const [
    openAdministrativeRoleDelete,
    setOpenAdministrativeRoleDelete
  ] = useState(false);

  const handleCloseDeleteModal = () => {
    setOpenAdministrativeRoleDelete(false);
  };

  const handleCloseModelForm = () => {
    setOpenAdministrativeRoleForm(false);
  };

  const handleClickMore = option => {
    if (option === CommonActions.EDIT) {
      setOpenAdministrativeRoleForm(true);
    }
    if (option === CommonActions.DELETE) {
      setOpenAdministrativeRoleDelete(true);
    }
  };

  const handleDeleteModal = useCallback(() => {
    dispatch(deleteAdministrativeRoleAction(id, handleCloseDeleteModal));
  }, []);

  const handleEdit = useCallback(
    values => {
      dispatch(editAdministrativeRoleAction(values, handleCloseModelForm));
    },
    [id]
  );

  return (
    <TableRow hover>
      <TableCell align="start">{name}</TableCell>
      <TableCell align="right">
        <MoreMenu handleClickOption={handleClickMore} />
      </TableCell>

      <AdministrativeRolesForm
        data={{ name, id }}
        open={openAdministrativeRoleForm}
        onClose={handleCloseModelForm}
        onEdit={handleEdit}
      />
      <ConfirmationDialog
        open={openAdministrativeRoleDelete}
        handleClose={handleCloseDeleteModal}
        title={t(
          'CATALOGS_VIEW.ADMINISTRATIVES_ROLES.DELETE_ADMINISTRATIVE_ROLE_TITLE'
        )}
        description={t(
          'CATALOGS_VIEW.ADMINISTRATIVES_ROLES.DELETE_ADMINISTRATIVE_ROLE_DESCRIPTION'
        )}
        onSubmit={handleDeleteModal}
      />
    </TableRow>
  );
};

AdministrativeRolesRow.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string
};

export default AdministrativeRolesRow;
